import React from 'react';
import Header from '@components/Header';
import Footer from '@components/Footer';
import PlanSection from '@components/PlanSection';
import PricingTable from '@components/PricingTable';
import MobilePricingTable from '@components/MobilePricingTable';
import LandingPricing from '@components/LandingPricing';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const useStyles = makeStyles(() => ({
  root: {
    overflow: 'hidden',
  },
}));

const Index = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Head>
        <title>Pricing - SellOnLive</title>
      </Head>
      <Header />
      <LandingPricing />
      <MobilePricingTable />
      <PricingTable />
      <PlanSection />
      <Footer />
    </div>
  );
};

export const getServerSideProps = async ({ locale }) => {
  return {
    props: {
      locale,
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};
export default Index;
